let lockCount = 0;
let savedScrollY = 0;

export function lockPageScroll(): void {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    document.documentElement.classList.add("scroll-locked");
    document.body.classList.add("scroll-locked");
    document.body.style.top = `-${savedScrollY}px`;
  }

  lockCount += 1;
}

export function unlockPageScroll(): void {
  if (lockCount <= 0) {
    return;
  }

  lockCount -= 1;

  if (lockCount === 0) {
    document.documentElement.classList.remove("scroll-locked");
    document.body.classList.remove("scroll-locked");
    document.body.style.top = "";
    window.scrollTo(0, savedScrollY);
  }
}
